export default __webpack_public_path__ + "static/media/bicycle-solid.d5e3d5ce.svg";